var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-187f929b": "",
    "data-v-aba6859c": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.767354 15.1621V15.6488L0.174011 15.4521L0.767354 15.1621Z",
    fill: "#224735"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2002 23.4768V30.16L31.5429 22.7166V16.1599L21.2002 23.4768Z",
    fill: "#429E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.8371L22.2953 22.7025L0.768682 15.6482V11.6203L4.92044 13.0136C4.92044 13.0136 1.17104 11.0396 0 10.097V7.72681C0 7.72681 6.29002 13.4976 21.7111 17.0924L30.9836 10.1435V11.5491L31.9042 11.7626L32 15.8371Z",
    fill: "#429E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30515 13.0952V18.4455L12.2948 19.4252V14.2891C11.2225 13.8916 10.2269 13.4914 9.30515 13.0952Z",
    fill: "#F5B95F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.174286 15.453V21.6799L21.2001 30.16V23.4768L0.174286 15.453Z",
    fill: "#429E71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31912 18.9427V25.3681L12.3628 26.5957V20.1043L9.31912 18.9427Z",
    fill: "#F5B95F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2952 22.7026L21.2003 23.4772L0.174835 15.4534L22.2952 22.7026Z",
    fill: "#64AB88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9838 10.1432L21.7104 17.0932C18.2005 16.2366 15.0472 15.2965 12.2505 14.2865C11.1972 13.9065 10.1938 13.5165 9.24048 13.1165C5.25716 11.4499 2.17049 9.62654 0.000488281 7.72656C3.72054 5.20988 7.46387 3.31657 11.2338 1.99988C14.2408 4.4597 17.6804 6.1919 21.3039 7.50321C24.0705 8.50321 27.2605 9.37988 30.9838 10.1432Z",
    fill: "#64AB88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0105 15.923C12.8059 13.8505 6.39125 11.2312 2.25391 8.27411C2.57326 8.07538 2.58799 7.61574 2.28193 7.39709C4.97315 5.72318 7.72441 4.34967 10.4939 3.29785C10.7847 3.51585 11.1661 3.57084 11.5054 3.44058C15.5457 6.49263 20.6387 8.69187 27.6157 10.3823C27.2593 10.6494 27.3747 11.2111 27.8076 11.3161L21.8992 15.7439C21.5912 15.6668 21.2642 15.7321 21.0105 15.923Z",
    fill: "#429E71"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 15.8372L22.2953 22.7026V18.9707L31.9043 11.7627L32.0001 15.8372Z",
    fill: "#64AB88"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9834 10.1436V11.5491L21.711 18.4286V17.0924L30.9834 10.1436Z",
    fill: "#429E71"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9041 11.7627L22.2952 18.9707L21.711 18.4287L30.9834 11.5492L31.9041 11.7627Z",
    fill: "#64AB88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.9205 13.0135L0.768738 11.6202L1.67711 11.2012C1.67711 11.2012 3.93395 12.54 4.9205 13.0135Z",
    fill: "#224735"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.5433 16.16V19.3024L22.2953 22.7031L31.5433 16.16Z",
    fill: "#224735"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.7416 8.68966C18.7416 8.68966 20.9207 10.0327 17.3422 11.525C13.7637 13.0172 12.2272 11.9523 11.8512 11.2932C11.665 10.9667 11.6693 9.47165 13.8135 8.54442C15.9577 7.61719 17.9824 8.15795 18.7416 8.68966Z",
    fill: "#ffffff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.5406 13.2617C21.0294 13.8919 20.3806 13.4422 20.2218 13.1639C20.1431 13.026 20.1449 12.3946 21.0504 12.003C22.6001 11.3329 24.5594 12.4199 22.5406 13.2617Z",
    fill: "#ffffff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.11244 7.56847C7.11244 7.56847 6.19226 7.00134 7.70348 6.37115C9.2147 5.74095 9.86349 6.19066 10.0223 6.46899C10.1009 6.60685 10.0991 7.23818 9.19354 7.62976C8.28803 8.02134 7.43306 7.793 7.11244 7.56847Z",
    fill: "#ffffff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 7.50321L12.2505 14.2865C11.1972 13.9065 10.1939 13.5165 9.24051 13.1165L18.3305 6.30322C19.2639 6.72323 20.2539 7.12321 21.3039 7.50321Z",
    fill: "#F5B95F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.77745 18.6002L9.31912 18.943C10.2725 19.343 11.301 19.7281 12.3543 20.1082L12.9701 19.6467L9.77745 18.6002Z",
    fill: "#224735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.c9afe09eb6c4e8a2d3cd572ea69ec9f0.svg";
export { ForwardRef as ReactComponent };